export const NEW_SETUP_EVENTS = {
  // MFE -> host app
  CREATE_PANEL: 'mfe-new-setup-create-panel',

  // MFE -> host app
  SETUP_OPTIONS_UPDATED: 'mfe-new-setup-options-updated',

  // MFE -> host app
  GO_TO_SEARCH: 'mfe-new-setup-go-to-search',

  // MFE -> host app
  CONTINUE_EDITING: 'mfe-new-setup-continue-editing',

  // Host app -> MFE
  CREATE_PANEL_SUCCESS: 'mfe-new-setup-create-panel-success',
  CREATE_PANEL_ERROR: 'mfe-new-setup-create-panel-error',
} as const;

export type NewSetupEventName = (typeof NEW_SETUP_EVENTS)[keyof typeof NEW_SETUP_EVENTS];
